<template>

  <div class="fin-deci-text" :style="estilos" id="texto-final" tabindex="1">
    <v-flex text-xs-right>
      <ui-lsc-dialog @hideVideo="hideVideo" :vidTittle="'Conclusión'" :videoEmbed="video"></ui-lsc-dialog>
    </v-flex>
    <div class="text-ocul">&nbsp;</div>
    <div v-if="finTitulos" :aria-label="finTitulos[0]+finTitulos[1]+finTitulos[2]">
      <div class="text-ocul">
        <p>{{finTitulos[0]+finTitulos[1]+finTitulos[2]}}</p>
      </div>
      <div aria-hidden="true">
        <p class="font-red davi-curs fint-titu-1">{{finTitulos[0]}}</p>
      </div>
      <div aria-hidden="true" class="fint-titu-2">
        <p>{{finTitulos[1]}}</p>
      </div>
      <div aria-hidden="true" class="fint-titu-3">
        <p>
          <image-app :imaSize="30" imaSrc="design/red-arrow" imaAlt=""></image-app>
          <strong>{{finTitulos[2]}}</strong>
        </p>
      </div>
    </div>
    <div v-if="finTitulosDos">
      <p class="font-red davi-curs fint-titu-1">
        <image-app :imaSize="30" imaSrc="design/red-arrow" imaAlt=""></image-app>
        <strong>{{finTitulosDos}}</strong>
      </p>
    </div>
    <div class="fin-titu-cont">
      <slot></slot>
      <button tabindex="1" @click="backIni()" aria-label="Volver al inicio"></button>
      <button tabindex="1" @click="finDeci()" aria-label="Continuar curso"></button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    finTitleWidth: {
      type: String,
      default: "350"
    },
    finTitulos: {
      type: Array,
      required: false
    },
    finTitulosDos: {
      type: String,
      required: false
    },
    video:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      estilos: {
        width: this.finTitleWidth + "px"
      }
    };
  },
  methods: {
    hideVideo(){},
    backIni() {
      document.getElementById("inicio-decisiones").focus();
    },
    finDeci(){
      setTimeout(function() {
        document.getElementById('nav-adel-bot').focus();
      }, 100);      
    }
  }
};
</script>


<style lang="scss" scoped>
p {
  margin: 0;
}
.fin-deci-text {
  padding: 10px;
  left: 570px;
  top: 80px;
  .fint-titu-1 {
    font-size: 1.5rem;
  }
  .fint-titu-2 {
    padding-left: 25px;
  }
  .fint-titu-3 {
    padding-left: 100px;
    font-size: 1.4rem;
    margin-bottom: 10px;
  }
  .fin-titu-cont {
    padding-left: 10px;
    padding-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// ActividadDeciTituUno.vue?00248442